<template>
<div class="chapter">
<div class="inner_page">
<div class="titlePage" id="tit01">
<a id="page01">
<h1 class="title">Contours Of Darkness</h1>
<h2 class="subtitle">The Vassi Collection: Volume V</h2>
<p class="author">Marco Vassi</p>
<p class="colophon"><img alt="Open Road logo" src="Images/logo.png" width="60%"/></p>
</a></div>
<a id="page01">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contoursofdarkness_tit01.vue?5d6dc800